import { config } from 'src/config/config'
import { apiCall } from 'src/utils/networking'

export const api = {
	getTagsList: async () =>
		apiCall(`${config.baseAPIUrl}/tag/list`, {
			method: 'POST',
		}),
}
